import {css} from '@emotion/core';
import styled from '@emotion/styled';
import { FontNormal } from "@css/fonts";
import { fontSize } from "@css/styles";
import { lightBlue, mobileMax } from "@css/constants";

export type IconListContainerProps = {
  minWidth?: string
}

export const IconListContainer = styled('div')<IconListContainerProps>((props) => css`
  list-style: none;
  justify-content: space-around;
  text-align: left;
  margin: auto;
  min-width: ${props.minWidth ? props.minWidth : ''};
`);

interface IconListItemContainerProps {
  showIconsConnected?: boolean;
}

export const IconListItemContainer = styled('div')<IconListItemContainerProps>(props => css`
  padding-top: 0.75rem;
  padding-bottom: ${props.showIconsConnected ? '0' : '0.75rem'};
  &: after {
    content: "";
    clear: both;
    display: table;
  }
`)

export const IconListItemIconWrapper = styled('div')(css`
  float: left;
`)

export interface IconListItemIconProps {
  iconSize?: number;
}

export const IconListItemIcon = styled('div')<IconListItemIconProps>((props) =>css`
  svg {
    width:  ${props.iconSize}px;
    height: ${props.iconSize}px;
  }
`);

export interface IconListItemProps {
  fontSize?: number;
  fontSizeMobile?: number;
  fontNorm?: number;
  marginLeft?: string;
  marginLeftMobile?: string;
}

export const IconListItemText = styled('div')<IconListItemProps>((props) =>css`
  ${FontNormal( props.fontNorm || 400)};
  ${fontSize(props.fontSize || 14)};
  
  margin-top: 5px;
  margin-left: ${props.marginLeft ? props.marginLeft : '36px'};
  vertical-align: top;

  @media(max-width: ${ mobileMax }) {
    ${fontSize(props.fontSizeMobile || props.fontSize || 14)}
    margin-left: ${props.marginLeftMobile ? props.marginLeftMobile : '36px'};
  }
`)

export const IconListItemConnector = styled('div')(css`
  margin: 7px 0 0 11px;
  width: 1px;
  height: 28px;
  background-color: ${lightBlue};
`)
